import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol viewBox=\"0 0 11 7\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down\"><path d=\"M.837 1.12L5.371 6.1l4.474-4.98-.6-.65L5.37 4.781 1.437.471l-.6.649z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol